import React, { Component } from 'react';
import { connect } from 'react-redux';
import {InputText} from 'primereact/inputtext';
import {DataTable} from 'primereact/datatable'
import {Column} from 'primereact/column';
import {Button} from 'primereact/button';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';

import {Toast} from 'primereact/toast';
import { DATATABLE_CONFIG, KEYWORD_SUBMENU_ID} from '../../../shared/Config';
import { HASACCESS, scrollToTop } from '../../../shared/utility';
import Messages from '../../../shared/UI/Messages/Messages';
import * as actions from '../../../store/actions/index';


class KeywordMaster extends Component {
    state = {
        keywordValues: [
            {
                kEywordId:0,
                KeywordText:'',    
                KeywordValue:'',
                Isactive: true
            }
        ],
        KeywordName:'',
        type: 'add',     
        Createdby : (this.props.loggedUserDetail.userName) ?? 'Admin',
        Createddate : new Date(),
        CompanyId: this.props.loggedUserDetail.CompanyId,
        touch: false
    }



    actionTemplate = (rowData) => {

        return <div className="actionCenter">
                {(this.getAccess!==undefined && this.getAccess.editAccess!== false) &&
                <Button onClick={() => this.editItem(rowData,'edit')}  type="button" icon="pi pi-pencil" className="p-button-info" ></Button>
                }
                {(this.getAccess!==undefined && this.getAccess.viewAccess!== false) &&
                <Button type="button" icon="pi pi-eye"  className="p-button-secondary" onClick={()=>this.editItem(rowData,'view')} ></Button>
                }
            </div>;
    }

   
    addKeyword = () => {   
        let KeywordName = this.state.KeywordName;
        let keywordValues = this.state.keywordValues;
       

        if(keywordValues.length > 0 ){
    
            var err = false;
            var data = keywordValues.map(keyword=>{
               
                if(keyword.KeywordText === '' || keyword.KeywordValue=== ''){
                    this.growl.show({severity: 'error', summary: null, detail: 'Keyword text and value Should not be empty'});
                    err = true
                    return '';
                }

                if(this.state.type === 'edit'){
                    return {
                         kEywordId : keyword.kEywordId,
                         KeywordName: KeywordName,            
                         KeywordText: keyword.KeywordText,
                         KeywordValue: keyword.KeywordValue,
                         ModuleId:null,
                         Isactive: keyword.Isactive,
                         CompanyId: this.state.CompanyId,
                         Createdby: this.state.Createdby,
                         Createddate: this.state.Createddate,
                     }
                }else{
                    return {
                        // kEywordId : keyword.kEywordId,
                         KeywordName: KeywordName,            
                         KeywordText: keyword.KeywordText,
                         KeywordValue: keyword.KeywordValue,
                         ModuleId:null,
                         Isactive: keyword.Isactive,
                         CompanyId: this.state.CompanyId,
                         Createdby: this.state.Createdby,
                         Createddate: this.state.Createddate,
                     }
                }
        

            });

            let valueData = {
                Keyword : data
            }

            if(err === false){
                this.props.processDynamicData('Keyword',this.state.type,valueData,'GetKeyword');
                setTimeout(() => {
                    if(this.props.success !== null ){
                        this.clear();
                    }
                }, 3000);
            }


        }else{
            this.growl.show({severity: 'error', summary: null, detail: 'Keyword text and value is required'});
            return;
        }
    }


  
    clear = () => {
        this.setState({
            type: 'add',
            KeywordName : '', 
            keywordValues: [
                {
                    kEywordId:0,
                    KeywordText:'',    
                    KeywordValue:'',
                    Isactive: true
                }
            ]
        });
    }



    editItem = (rowData,type) => {
        scrollToTop();

        if(rowData.keywordName !=='' || rowData.keywordName !==undefined){

            let keywordName = rowData.keywordName;
            
            let filterData = [];
            if(this.props.tableLists && this.props.tableLists.length > 0){
               filterData = this.props.tableLists.filter(table=>{
                   return table.keywordName === keywordName;
               })
            }

            let keywordData = []
            if(filterData && filterData.length > 0){
                keywordData = filterData.map(item=>{
                   return {
                    kEywordId: item.kEywordId,
                    KeywordText:item.keywordText,    
                    KeywordValue:item.keywordValue,
                    Isactive: item.isactive
                   }
                })
            }
      

            this.setState({type:type,KeywordName:keywordName,keywordValues:keywordData})

        }else{
            this.growl.show({severity: 'error', summary: null, detail: 'Entry has error.'});
            return;
        }


    }


    addFields = (e) => {
        e.preventDefault();
       
        let newValue = {
            kEywordId:0,
            KeywordText:'',    
            KeywordValue:'',
            Isactive: true
        }
        let value = [...this.state.keywordValues, newValue];
        this.setState({keywordValues:value})
    }

    changeKey = (e) => {
        let {name ,value} = e.target;
        this.setState({[name]:value,touch:true})
    }

    change = (e, index) => {
        e.preventDefault();
        const { name, value } = e.target;
        const newValue = [...this.state.keywordValues];
        newValue[index][name] = value;
        this.setState({keywordValues:newValue,touch:true})
    } 

    removeFields = (e, index) => {
        e.preventDefault();
     
        const updatedValue = this.state.keywordValues.filter((field, i) => {
            return index !== i;
        });
        
        this.setState({keywordValues:updatedValue})
    }

    componentDidMount(){
        this.props.getMasterTableList('GetKeyword');
        this.getAccess = HASACCESS(KEYWORD_SUBMENU_ID);
    }

    statusRender = (rowData) => {
        
        let status = <Button type="button" label="InActive" className="p-button-danger p-button-rounded" ></Button>
        if(rowData.isactive === true){
            status = <Button type="button" label="Active" className="p-button-success p-button-rounded" ></Button>
        }
        return <div className="actionCenter">
                    {status}
               </div>;
    }


    render() {   

        let addAccess = true;
        let editAccess = true;

        if(this.getAccess!==undefined){
            if(this.getAccess.viewAccess === false){this.props.history.push('/dashboard')}
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess : addAccess, editAccess : editAccess}

        
        const tableData = [];
        if(this.props.tableLists && this.props.tableLists.length > 0){
            const map = new Map();
            for (const item of this.props.tableLists) {
                if(!map.has(item.keywordName)){
                    map.set(item.keywordName, true);    // set any value to Map
                    tableData.push(item);
                }
            }
        }
       



        const header = (
            <div style={{'textAlign':'right'}}>
                <InputText type="search" onInput={(e) => this.setState({globalFilter: e.target.value})} placeholder="Search..." />
            </div>
        );
        
        
        
        let isEnabled = (this.state.KeywordName !== '') && (this.state.keywordValues.length > 0) && (this.state.touch === true);

        
       
        
        return (
            <div className="p-grid padding">
               { this.props.loading && <div className="page-loader"></div>}
               { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
               { this.props.success !== null && <Messages type="success" message={this.props.success}/>}
               <Toast ref={(el) => this.growl = el} />
               <div className="p-col-12">
                    <div className="card card-w-title" style={{position:'relative'}}>
                        <h1>Keyword Master</h1>
               
                        <div className="p-grid">

                            <div className="p-col-12 p-md-6 p-lg-4">
                                <div className="mt1 ">
                                <InputText className="width100" placeholder="Enter Keyword Name" name="KeywordName" value={this.state.KeywordName} onChange={this.changeKey} />
                                </div>                                
                            </div>

                            { this.state.keywordValues.length > 0 && 
                                <>
                                {
                                this.state.keywordValues.map((keyword,index) => {
                                   
                                    
                                    return(
                                        <div className="p-col-12" key={index}> 
                                            <div className="card card-w-title">
                                                <div className="p-grid">
                                                    <div className="p-col-12 p-md-6 p-lg-4">
                                                        <div className="mt1 ">
                                                        <InputText className="width100" placeholder="Text" name="KeywordText" value={keyword.KeywordText} onChange={(e) => this.change(e, index)} />
                                                        </div>                                
                                                    </div>

                                                    <div className="p-col-12 p-md-6 p-lg-4">
                                                        <div className="mt1 ">
                                                        <InputText className="width100" placeholder="Value" name="KeywordValue" value={keyword.KeywordValue} onChange={(e) => this.change(e, index)} />
                                                        </div>                                
                                                    </div>


                                                    <div className="p-col-12 p-md-6 p-lg-4">
                                                        <div className="mt1 ">
                                                            {(index ===0) ? 
                                                                <Button onClick={(e) => this.addFields(e)} title={`Add Fields`} icon="pi pi-plus" className="p-button-success"/>

                                                            : null}

                                                            {(index!==0 && (keyword.kEywordId ===0)) ? 
                                                            <Button  onClick={(e) => this.removeFields(e, index)} title={`Remove Fields`} icon="pi pi-trash" className="p-button-danger"/>

                                                            : null}
                                                        </div>                                
                                                    </div>



                                                </div>
                                            </div>
                                        </div>


                                    )
                                })
                                    
                                }
                                
                                </>
                                }
                                <div className="p-col-12 p-md-6 p-lg-12">
                                
                                
                                <FooterButton access={accessButton} disabled={!isEnabled} type={this.state.type.toLowerCase()} save={this.addKeyword} reset={this.clear}  to="" />


                                </div>
                     

                      
                            					 	
                            <div className="p-col-12" style={{marginTop:'2em'}}>
                        
                                <DataTable ref={(el) => this.dt = el} value={tableData} globalFilter={this.state.globalFilter} header={header}  {...DATATABLE_CONFIG}>
                                    <Column field="keywordName" header="Keyword Name" />
                                    <Column field="isactive" header="Status" body={this.statusRender}/>
                                    <Column body={this.actionTemplate} header="Edit" />
                                </DataTable>
                        </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        loading : state.master.loading,
        error : state.master.error,
        tableLists : state.master.tableLists,
        success: state.master.success
    }
}
  
const mapDispatchToProps = dispatch => {
    return{
        processDynamicData: (model,type,data,func) => dispatch(actions.processDynamicData(model,type,data,func)),
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
    }
}

  
export default connect(mapStateToProps,mapDispatchToProps)(KeywordMaster);